// Keep the current item visible in horizontally scrolling navigation. On a
// phone the active Astrology destination may be Houses, at the far end of the
// row; showing the start of the row would display navigation without showing
// the reader where they are.
function centerCurrent(container, selector) {
  const current = container.querySelector(selector);
  if (!current || container.scrollWidth <= container.clientWidth) return;

  // offsetLeft is measured from the nearest positioned ancestor, which is not
  // necessarily the scrolling list. On phones that extra offset clipped the
  // first letters of the active section. Measure in viewport coordinates and
  // translate back into this container's scroll space instead.
  const containerBox = container.getBoundingClientRect();
  const currentBox = current.getBoundingClientRect();
  const currentCentre = (
    currentBox.left - containerBox.left + container.scrollLeft + (currentBox.width / 2)
  );

  container.scrollLeft = Math.max(
    0,
    currentCentre - (container.clientWidth / 2)
  );
}

export function start() {
  requestAnimationFrame(() => {
    document.querySelectorAll(".sectionbar__nav").forEach((nav) => {
      centerCurrent(nav, ".sectionbar__link--on");
    });
  });
}

document.addEventListener("DOMContentLoaded", start);
document.addEventListener("turbo:load", start);
